/**
 * RTK queries or mutations types
 */
export const TAG_TYPES = [
  'AccrualSummary',
  'AccrualBenefitTransactions',
  'Availability',
  'Calendar',
  'Notifications',
  'Users',
  'Departments',
  'Timesheet',
] as const;

export type TagTypesType = typeof TAG_TYPES;
